/** Presentacion de la bandeja del revisor: prioridad y vencimiento (SLA) en palabras, sin logica de negocio. */
import type { ReviewPriority } from './queries';

export const PRIORITY_LABEL: Record<ReviewPriority, string> = { 0: 'Baja', 1: 'Normal', 2: 'Alta', 3: 'Crítica' };

/** Clase `pill--*` de styles.css por prioridad. */
export const PRIORITY_PILL: Record<ReviewPriority, string> = {
  0: 'pill--neutral',
  1: 'pill--info',
  2: 'pill--warning',
  3: 'pill--critical',
};

/** "vencida hace 5 h", "vence en 3 días"... a partir de `hours_to_due` (negativo = ya vencida). */
export function dueLabel(hoursToDue: number): string {
  const abs = Math.abs(Math.round(hoursToDue));
  const span = abs < 48 ? `${abs} h` : `${Math.round(abs / 24)} días`;
  return hoursToDue < 0 ? `vencida hace ${span}` : `vence en ${span}`;
}

/** Antiguedad de la tarea ("hace 3 h" / "hace 2 días"). */
export function ageLabel(ageHours: number): string {
  const h = Math.max(0, Math.round(ageHours));
  return h < 48 ? `hace ${h} h` : `hace ${Math.round(h / 24)} días`;
}

/** Plazo (SLA) por prioridad, en horas. Espejo de SLA_HOURS en fase5/review-queue.ts del backend. */
export const SLA_HOURS: Record<ReviewPriority, number> = { 0: 240, 1: 120, 2: 72, 3: 24 };

export const PRIORITIES: ReviewPriority[] = [3, 2, 1, 0];

/** "Crítica · 24 h" para el selector de prioridad. */
export function priorityOptionLabel(p: ReviewPriority): string {
  return `${PRIORITY_LABEL[p]} · ${SLA_HOURS[p]} h`;
}

/**
 * Personas a las que se puede ofrecer una revision: quienes tienen el rol Revisor RAT o Administrador (los unicos con
 * `activity.review`). Sin duplicados y ordenadas por correo. Si ese revisor puede o no revisar ESA unidad lo decide el
 * backend al asignar (`assignee_not_eligible`), porque depende de su alcance.
 */
export function reviewerCandidates(
  assignments: Array<{ user_id: string; email: string | null; role: string }>,
): Array<{ id: string; email: string }> {
  const seen = new Map<string, string>();
  for (const a of assignments) {
    if ((a.role === 'revisor_rat' || a.role === 'admin_rat') && !seen.has(a.user_id)) seen.set(a.user_id, a.email ?? a.user_id);
  }
  return [...seen].map(([id, email]) => ({ id, email })).sort((x, y) => x.email.localeCompare(y.email, 'es'));
}
